var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"architecture"},[_c('div',{staticClass:"title"},[_vm._v("平台架构图")]),_c('div',{staticClass:"bg-img"})])
}]

export { render, staticRenderFns }